import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import './styles.scss';

type PropsType = {
    image?: string | null;
    label?: string;
    className?: string;
    style?: React.CSSProperties;
    size?: number;
    onClick?: (event: React.SyntheticEvent) => void;
    children?: React.ReactNode;
};

const colors = ['#ff6384', '#36a2eb', '#ffce56', '#4bc0c0', '#9966ff', '#ff9f40', '#00bcd4', '#009688', '#8bc34a', '#f44336'];

export const UiAvatar = observer(function UiAvatar({ image = null, label = '', className = '', style = {}, size = 48, onClick, children }: PropsType) {
    const classNames = classnames('ui-new-avatar', className);

    const fontSize = useMemo(() => {
        let multiplier = size < 27 ? 10 / 24 : 23 / 48;
        let fontSize = Math.ceil(size * multiplier);
        if (fontSize > 28) {
            fontSize = fontSize * 0.75;
        }
        return fontSize + 'px';
    }, [size]);

    const name = useMemo(() => {
        if (!!image || !label || !label.trim()) {
            return null;
        }
        let nameData = label.trim().split(' ');
        if (nameData.length > 1) {
            return nameData[0].substring(0, 1).toUpperCase() + nameData[1].substring(0, 1).toUpperCase();
        } else {
            return nameData[0].substring(0, 2).toUpperCase();
        }
    }, [image, label]);

    const color = useMemo(() => {
        if (!name || name.length < 1) {
            return colors[0];
        }
        return colors[(name.split('')[0].charCodeAt(0) + (label?.length || 0)) % colors.length];
    }, [name, label]);

    return (
        <div
            className={classNames}
            onClick={onClick}
            style={{
                width: size,
                height: size,
                minWidth: size,
                minHeight: size,
                backgroundImage: image ? `url(${image})` : undefined,
                backgroundColor: image ? undefined : color,
                fontSize,
                ...style,
            }}
        >
            {name && <div style={{ fontSize: fontSize, lineHeight: fontSize }}>{name}</div>}
            {children}
        </div>
    );
});
